<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>市场管理</el-breadcrumb-item>
                    <el-breadcrumb-item>复借率统计</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox" v-loading="loading">
                <div class="listright">
                    <el-table :data="list" height="800"
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="alsoTime" label="应还时间"></el-table-column>
                        <el-table-column prop="alsoNum" label="应还笔数"></el-table-column>
                        <el-table-column prop="hasNum" label="已还笔数"></el-table-column>
                        <el-table-column prop="penNum" label="在借笔数"></el-table-column>
                        <el-table-column prop="penNo" label="在借已还笔数"></el-table-column>
                        <!-- <el-table-column prop="borrRate" label="复借率"></el-table-column> -->
                        <el-table-column prop="borrRate1" label="在借已还率"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                loading: false,
                list: [],
            }
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                this.loading = true
                _api.get(apiurl.complexPower, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.loading = false
                    this.list = res.data
                })
            }
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>